import Vue from 'vue'

const defaultSiteConfig = {
  name: '青苹果',
  slogan: '探索技术，分享思考',
  description: '记录前端开发、软件推荐、教程实战与资源分享。涵盖 Vue、JavaScript、性能优化、小工具推荐等内容。',
  keywords: '技术博客,前端开发,Vue,JavaScript,软件推荐,教程,编程学习,性能优化,小工具',
  author: '青苹果',
  locale: 'zh_CN',
  language: 'zh-CN',
  themeColor: '#2563eb',
  url: process.env.VUE_APP_SITE_URL || 'https://www.wyqii.cn',
  twitter: '@blog',
  // 默认联系邮箱（页脚固定展示兜底）
  contactEmail: 'l77895@qq.com',
  feedbackEmail: 'l77895@qq.com',
  email: 'l77895@qq.com',
  logoType: 'emoji',
  logoEmoji: '🍏',
  logoSubtitle: 'GreenApple Blog',
  logoUrl: '',
  faviconUrl: '',
  icpNumber: '',
  icpUrl: 'https://beian.miit.gov.cn/',
  domainFilings: [],
  copyrightYear: new Date().getFullYear(),
  copyrightYearEnd: null,
  copyrightYearDisplay: String(new Date().getFullYear()),
  footerTip: '本站内容仅供学习交流，转载请注明出处',
  footerChannels: {
    miniprogram: { enabled: false, label: '小程序', tip: '微信扫一扫打开', imageUrl: '' },
    wechat: { enabled: false, label: '公众号', tip: '扫码关注', imageUrl: '' }
  },
  grayscaleMode: false,
  grayscaleDates: [],
  navItems: [],
  articleCopyright: null
}

/** Vue.observable：后台改邮箱等字段后页脚/顶栏会立刻重绘 */
export const siteConfig = Vue.observable({ ...defaultSiteConfig })

export function formatCopyrightYears(start, end = null) {
  const yearStart = Number(start) || new Date().getFullYear()
  const yearEnd = end ? Number(end) : null
  if (!yearEnd || yearEnd <= yearStart) return String(yearStart)
  return `${yearStart}-${yearEnd}`
}

export function applyRuntimeSiteConfig(data) {
  if (!data || typeof data !== 'object') return
  const copyrightYearDisplay = data.copyrightYearDisplay
    || formatCopyrightYears(data.copyrightYear, data.copyrightYearEnd)
  // 后台未填站点 URL 时保留构建时的 VUE_APP_SITE_URL，避免分享链接变成相对路径
  const nextUrl = typeof data.url === 'string' ? data.url.trim() : ''
  const contactEmail = data.contactEmail != null ? String(data.contactEmail).trim() : (data.email || '')
  const feedbackEmail = data.feedbackEmail != null
    ? String(data.feedbackEmail).trim()
    : contactEmail
  Object.keys(data).forEach((key) => {
    if (key === 'url' || key === 'contactEmail' || key === 'feedbackEmail' || key === 'email' || key === 'copyrightYearDisplay') {
      return
    }
    Vue.set(siteConfig, key, data[key])
  })
  Vue.set(siteConfig, 'url', nextUrl || siteConfig.url)
  Vue.set(siteConfig, 'contactEmail', contactEmail || 'l77895@qq.com')
  Vue.set(siteConfig, 'feedbackEmail', feedbackEmail || contactEmail || 'l77895@qq.com')
  Vue.set(siteConfig, 'email', contactEmail || 'l77895@qq.com')
  Vue.set(siteConfig, 'copyrightYearDisplay', copyrightYearDisplay)
}

export function getDefaultSiteConfig() {
  return { ...defaultSiteConfig }
}

export default siteConfig
